import { useCallback } from "react";
import Select from "react-select";
import { useEstimatedSalaryStore } from "../../../../Store/CashControlStore/EstimatedSalaryaStore";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "200px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function Selector({ options, property }) {
  const { updateParams, loadItems, queryParams, setLoading } =
    useEstimatedSalaryStore();

  const handleSelectChange = useCallback(async (e) => {
    setLoading(true);
    updateParams({ year: e?.value == undefined ? "" : e?.value, page: 1 });
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        year: e?.value == undefined ? "" : e?.value,
        page: 1,
      }).toString()
    );
    setLoading(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
